import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';
import { Agency } from '../models/agency.models';

@Injectable({
  providedIn: 'root'
})
export class AgenciesService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;
  agencyUpdated = new BehaviorSubject<boolean>(false);
  agencyUpdated$ = this.agencyUpdated.asObservable();

  constructor() {}

  readAgencies(salesOfficeId?: string | null): Observable<Agency[]> {
    const queryParams = salesOfficeId ? `?salesOfficeId=${salesOfficeId}` : '';
    return this.#http.getData<Agency[]>(`${this.baseUrl}/agency${queryParams}`, {
      showLoader: true,
      showMessage: false
    });
  }

  readAgencyById(id: string): Observable<Agency> {
    return this.#http.getData<Agency>(`${this.baseUrl}/agency/${id}`, { showLoader: true, showMessage: false });
  }

  createAgency(payload: unknown): Observable<unknown> {
    return this.#http.postData<unknown>(`${this.baseUrl}/agency`, { showLoader: true, showMessage: true }, payload);
  }

  updateAgency(id: string, payload: unknown): Observable<unknown> {
    return this.#http.putData<unknown>(`${this.baseUrl}/agency/${id}`, payload, {
      showLoader: true,
      showMessage: true
    });
  }

  deleteAgency(id: string): Observable<unknown> {
    return this.#http.deleteData<void>(`${this.baseUrl}/agency/${id}`, { showLoader: true, showMessage: true });
  }
}
